// extracted by mini-css-extract-plugin
export var actions = "_53-0";
export var actionsContainer = "_53-7";
export var border = "_53-1";
export var childFullHeight = "_53-f";
export var collapse = "_53-2";
export var content = "_53-a";
export var contentChild = "_53-e";
export var fullscreen = "_53-c";
export var hasLeftRadius = "_53-k";
export var headerContainer = "_53-3";
export var headerRow = "_53-5";
export var hidePadding = "_53-b";
export var navCollapsedGap = "_53-l";
export var noScrollX = "_53-m";
export var noScrollY = "_53-n";
export var noTopPadding = "_53-i";
export var optOutTopPadding = "_53-d";
export var pageMain = "_53-j";
export var pageOuter = "_53-g";
export var pagePadding = "_53-8";
export var pageScroll = "_53-9";
export var profile = "_53-o";
export var profileContainer = "_53-p";
export var profileImage = "_53-q";
export var profileMain = "_53-r";
export var profileSubtitle = "_53-t";
export var profileTitle = "_53-s";
export var showLeftPadding = "_53-h";
export var tabsPortalSlot = "_53-6";
export var tabsWrapper = "_53-4";
export var title = "_53-u";